export default {
  id: 'ui-video.actions.Fullscreen',
  appearance: ({
    context
  }) => {
    const {
      isLoading,
      isFullscreen
    } = context;
    return {
      icon: isFullscreen ? 'fa fa-fw fa-compress' : 'fa fa-fw fa-expand',
      disabled: isLoading
    };
  },
  matches: {
    use: 'videoOptionsBar'
  },
  handles: context => {
    const {
      fullscreenSupported
    } = context;
    return fullscreenSupported;
  },
  layout: {
    sort: 'zzz'
  },
  perform: ({
    context
  }) => {
    const {
      onFullscreen
    } = context;
    onFullscreen();
  }
};